import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useGetPriceList from '@hooks/INV/PriceList/useGetPriceList';

export const SelectPriceList = ({ value, onChange }: any) => {
  const { t, i18n } = useTranslation();

  const { PriceListOptions, loading } = useGetPriceList();

  return (
    <Select
      classNamePrefix='react-select'
      isLoading={loading}
      isSearchable={true}
      isClearable
      options={PriceListOptions}
      value={PriceListOptions?.find(f => f.value === value)}
      onChange={onChange}
      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
    />
  );
};
